export default __webpack_public_path__ + "static/BACWizard-7c844dce5b4613f65cc483f85e5a60c0.png";